import React from 'react';
const stamp=value=>{
  const d=value?new Date(value):null;
  return d&&Number.isFinite(d.getTime())?`${d.toLocaleString()} (${Intl.DateTimeFormat().resolvedOptions().timeZone}) · ${d.toISOString()} UTC`:'Not recorded';
};
export default function ResearchTiming({timing,answeredAt}) {
  if(!timing)return null;
  return <section className="card mb-4"><div className="card-body"><h5>Prediction window</h5><p className="text-muted">{timing.horizonNote}</p><dl className="row mb-0">
    <dt className="col-sm-3">Prediction time</dt><dd className="col-sm-9">{stamp(timing.createdAt)}</dd>
    <dt className="col-sm-3">Model-reported answer time</dt><dd className="col-sm-9">{stamp(answeredAt)} · Unverified</dd>
    <dt className="col-sm-3">Valid until</dt><dd className="col-sm-9">{stamp(timing.validUntil)}</dd>
    <dt className="col-sm-3">Target session (New York)</dt><dd className="col-sm-9">{timing.targetSession||'Not applicable / unavailable'} · {timing.targetKind}</dd>
    <dt className="col-sm-3">Lead time to expiry</dt><dd className="col-sm-9">{timing.leadHours==null?'Unknown':`${timing.leadHours} elapsed hours`}</dd>
    <dt className="col-sm-3">Prediction timing</dt><dd className="col-sm-9">{timing.label}</dd>
  </dl><p className="text-muted fs-12 mb-0">{timing.basis} Times and settlement rules are unchanged.</p></div></section>;
}
